// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"829":"902c1fd7","932":"9f1a7dc4"}[chunkId] + ".chunk.js";
};